<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      resizable
      size="mini"
      cell-class-name="align-top"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :max-height="500"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          label="SKU"
          labelKey="table_label_evgSkuNo"
          :value="row.evgSkuNo"
        />
      </template>
      <template v-slot:displaySpecColor="{ row }">
        <TableLabel :value="row.goodsSize" />
        <TableLabel
          :value="`${row.goodsColor || ''} ${row.goodsColorEn || ''} `"
        />
        <TableLabel :value="row.goodsPattern" />
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel
          label="UPC"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
        />
        <TableLabel
          label="ITEM"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
        />
        <TableLabel label="NC" labelKey="table_label_ncNo" :value="row.ncNo" />
      </template>
      <template v-slot:displayUnit="{ row }">
        <TableLabel
          label="单位"
          labelKey="table_label_skuPackSize"
          :value="row.v_skuPackSize"
        />
        <TableLabel
          label="入数"
          labelKey="table_label_specInUnitQty"
          :value="row.specInUnitQty"
        />
      </template>
      <template v-slot:unitPrice="{ row }">
        {{ format(row.unitPrice) || '' }}
        {{ row.v_ftyPriceCurrencyUnit || '' }}
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-header--column,
  .vxe-body--column {
    background-image: linear-gradient(transparent, transparent),
      linear-gradient(#e8eaec, #e8eaec) !important;
  }
}
</style>
